import React, { useEffect, useRef } from "react";
import "./earrings.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import imgLeft1 from "./images/layerLeft1.webp";
import imgLeft2 from "./images/layerLeft2.webp";
import imgRight1 from "./images/layerRight1.webp";
import imgRight2 from "./images/layerRight2.webp";
import earringImg from "./images/videoProduct.mp4";

export default function Earrings() {
  gsap.registerPlugin(ScrollTrigger);

  let col1Ref = useRef(null);
  let col2Ref = useRef(null);
  let col3Ref = useRef(null);
  let col4Ref = useRef(null);
  let titleRef = useRef(null);

  return (
    <div className="earrings-main">
      <div className="component-header" ref={(el) => (titleRef = el)}>
        <p>KOLCZYKI</p>
      </div>
      <div className="component-images">
        <div className="component-column column-left">
          <div className="left-content">
            <div className="left-image-1" ref={(el) => (col2Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Stanga 2"
                }
                alt=""
              />
            </div>
            <div className="left-image-2" ref={(el) => (col1Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Dreapta 22"
                }
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="component-column column-middle">
          <div className="middle-content">
            <div className="middle-image" />
            <a href="https://www.teilor.pl/kolczyki-z-18k-bialego-zlota-z-2-94ct-bezbarwnymi-diamentami-i-1-22ct-zoltymi-diamentami-122808.html">
              <video
                className="middle-video"
                playsinline="true"
                autoplay="true"
                loop="true"
                muted="true"
              >
                <source
                  src="https://cdn.media.amplience.net/v/teilor/Video_Produs_Polonia_Pozitia1/mp4_720p"
                  type="video/mp4"
                />
              </video>
            </a>
          </div>
        </div>
        <div className="component-column column-right">
          <div className="right-content">
            <div className="right-image-1" ref={(el) => (col3Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Stanga 22"
                }
                alt=""
              />
            </div>
            <div className="right-image-2" ref={(el) => (col4Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia Dreapta 2"
                }
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="component-content">
        <div className="component-content-title">
          <p>spektakularna </p>
        </div>
        <div className="component-content-text">
          <p>
            {" "}
            Biżuteria, która ma intrygować. Wyraziste kolczyki z tej kolekcji
            wyeksponują Twoją elegancję. Nadstaw uszu, bo czeka Cię moc
            komplementów.
          </p>
        </div>
      </div>
    </div>
  );
}
